import { useEffect } from "react";

/**
 * Freezes the page behind an overlay while it is open.
 *
 * Extracted from the three panels that each carried this effect inline
 * (ApplicantCVSheet, PublicApplicantPanel, JobStoryStrip) so every overlay locks —
 * and, more importantly, releases — the same way.
 *
 * Keyed off `isOpen` rather than mount: the AnimatePresence overlays stay mounted
 * while closed, so releasing only on unmount would leave the page frozen for good.
 * The previous value is saved and restored rather than cleared, so an overlay opened
 * on top of another one hands the lock back instead of unlocking the page underneath.
 *
 * @param {boolean} isOpen
 */
export const useBodyScrollLock = (isOpen) => {
  useEffect(() => {
    if (!isOpen) return undefined;
    const prev = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => { document.body.style.overflow = prev; };
  }, [isOpen]);
};

export default useBodyScrollLock;
